<template>
  <div>

    <el-dialog :visible.sync="addVisible" title="分配角色" @close="close">
      <LoadingNoDialog :loading="loading">
        <el-table
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          border
          :data="tableData"
          style="width: 100%">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            prop="roleName"
            label="角色名称"
          >
          </el-table-column>
          <el-table-column
            prop="remarks"
            label="备注"
          >
          </el-table-column>
          <el-table-column
            prop="sysCode"
            label="所属系统"
          >
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="创建时间">
          </el-table-column>
        </el-table>
        <!--<div style="margin-top: 10px;text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10,20, 50, 100, 500,1000]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>-->

      </LoadingNoDialog>
      <div class="margin-space" style="text-align: right">
        <el-button type="primary" @click="handleSure" :loading="addLoading" size="small">确定</el-button>

      </div>
    </el-dialog>

  </div>
</template>

<script>
  import LoadingNoDialog from '../../../components/LoadingNoDialog.vue'
  import axios from 'axios'
  import ElButton from "../../../../node_modules/element-ui/packages/button/src/button.vue";

  const moment = require('moment')

  export default {
    name: 'Role',
    data() {
      return {
        addVisible: false,
        tableData: [],
        loading: true,
        addLoading: false,
        page: 1,
        size: 10000,
        total: 0,
        userId: 0,
        roleRows: [],
        selectRows: [],
        addRoleObj: {
          roleName: '',
          remarks: ''
        }
      }
    },
    components: {
      ElButton,
      LoadingNoDialog
    },
    mounted() {
    },
    methods: {
      async getList() {
        this.loading = true
        let r = await axios.get('/admin/role/list', {params: {page: this.page, size: this.size}})
        this.tableData = r.data.rows.map(item => Object.assign(item, {createdAt: moment(item.createdAt).format('YYYY/MM/DD HH:mm:ss')}))

        this.total = r.data.count
        this.loading = false
        this.tableData.map(item => this.roleRows.findIndex(each => item.id == each.id) > -1 ? Object.assign(item, {isSelect: true}) : Object.assign(item, {isSelect: false}))
        this.$nextTick(() => {
          let rows = this.tableData.filter(item => item.isSelect == true)
          rows.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row);
          })
        })
      },
      handleSizeChange(val) {
        this.size = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.page = val
        this.getList()
      },
      addRoleClick() {
        this.addVisible = true
      },
      setVisible(flag, rows) {
        this.addVisible = flag
        this.roleRows = rows.roles
        this.userId = rows.id
        this.getList()
      },
      async addConfirmClick(val) {
        this.addLoading = true
        let r = await axios.post('/admin/role/create', this.addRoleObj)
        this.addLoading = false
        this.addVisible = false
        this.getList()
      },
      close() {

      },
      async handleSelectionChange(rows) {
        this.roleRows = rows
      },
      async handleSure() {
        this.addLoading = true
        let r = await axios.post('/admin/user-to-role', {userId: this.userId, roleIds: this.roleRows.map(item => item.id)})
        this.addLoading = false
        this.$emit('sure')
        this.addVisible=false
      }

    }
  }
</script>




// WEBPACK FOOTER //
// src/main/permission/components/RoleSelect.vue